import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Sale ")

import {computed, toRefs} from 'vue'
import {AgBoxS} from '@/components/ag'
import klaytnPng from './assets/klaytn.png'
import {currency} from '@/utils/filters'


export default /*#__PURE__*/_defineComponent({
  props: {
  chainKind: {default: 'KLAYTN', type: String},
  chainQuantity: {type: String},
  id: {default: 0, type: Number},
  imgSrc: {type: String},
  link: {type: String},
  title: {default: '', type: String},
},
  emits: ['visit-link'],
  setup(__props) {

const props = __props





const chainIcons: Record<string, string> = {
  KLAYTN: klaytnPng,
}

const {chainKind, chainQuantity} = toRefs(props)

const chainIcon = computed(() => chainIcons[chainKind.value])

const maskedChainQuantity = computed(() => currency(chainQuantity?.value))

return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return _withDirectives((_openBlock(), _createBlock(_unref(AgBoxS), {
    css: {
      overflow: 'hidden',
      border: '1px solid #EEF1F7',
      corner: 10,
      cursor: 'pointer',
      boxShadow: '0px 0px 8px rgba(174, 182, 199, 0.2)'
    },
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('visit-link', __props.link)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: __props.imgSrc,
            css: {width: '100%', height: 120, objectFit: 'cover'}
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {
        borderTop: '1px solid #EEF1F7',
        p: 16,
      } }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'h6', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%'} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row', alignItems: 'center', height: 20} }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), {
                "container-as": "img",
                src: _unref(chainIcon),
                css: {width: 12, height: 12, mr: 4}
              }, null, 8, ["src"]),
              _createVNode(_unref(AgBoxS), { css: {typography: 'h9', fontWeight: 'extraBold', mr: 4} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(maskedChainQuantity)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'h11', color: 'gray3'} }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["css"])), [
    [_directive_track, {clickContent: __props.title}]
  ])
}
}

})